export const getCustomDashboardLink = (dbId: string) => {
  return `/dashboard/custom/${dbId}`;
};

export const getCustomDashboardPageLink = (dbId: string, pageId: string) => {
  return `/dashboard/custom/${dbId}/${pageId}`;
};
